module.exports = __webpack_public_path__ + "img/1.fdff4aeb.png";